module.exports = __webpack_public_path__ + "img/appAsset-flag--US.1f8d7aab.svg";